import React, { useState, useEffect } from "react";
import { getStaticBySlug } from "../../../lib/staticRequests";
import { createMarkup } from "../../../utils/helper";
import { useRouter } from 'next/router';
import { formatTitle } from '../../../utils/helper';
import Loading from '../Loading';
import Head from "next/head";

export type Static = {
  id: string;
  name: string;
  body: string;
  show_title: boolean;
  slug: string;
  protected: boolean;
}

const Static = () => {
  const router = useRouter();
  const { slug } = router.query;
  const [activeStatic, setActiveStatic] = useState({} as Static);
  
  useEffect(() => {
    if(activeStatic && slug && activeStatic.slug !== slug[0]) {
      getStaticBySlug(slug[0]).then((response) => {
        setActiveStatic({
          ...activeStatic,
          ...(response.data as Static)
        })
      }).catch(err => router.push({pathname: "/users/sign_in", query: { from: router.asPath}}));
    }
  }, [slug]);

  return (
    <div className="container">
      <Head>
        {activeStatic?.name && <title>{formatTitle(activeStatic.name)}</title>}
      </Head>
      {
        !!activeStatic?.id ?
          <>
            {activeStatic.show_title && <h1 className="font-medium mb-2 text-3xl">{activeStatic.name}</h1>}
            <div className="article_content font-light" dangerouslySetInnerHTML={createMarkup(activeStatic?.body || "")}></div>
          </>
        :
          <Loading isLoading={true}/>
      }
    </div>
    
  )
}

export default Static;